import React from "react";
import {
  Edit,
  SimpleForm,
  TopToolbar,
  TextInput,
  ReferenceInput,
  SelectInput,
  required,
} from "react-admin";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ReferenceAutocomplete from "../../components/ReferenceAutocomplete";
import { DisabledDeleteButton } from "../../utils/validations";

const Actions = ({ onCancel }) => (
  <TopToolbar>
    <IconButton onClick={onCancel}>
      <CloseIcon />
    </IconButton>
  </TopToolbar>
);

const ProvinceEdit = (props) => (
  <Edit title=" " {...props} actions={<Actions {...props} />}>
    <SimpleForm
      redirect={props.basePath}
      variant="outlined"
      toolbar={<DisabledDeleteButton />}
    >
      <TextInput source="id" disabled fullWidth />
      <ReferenceAutocomplete
        fullWidth
        reference="countries"
        source="countryId"
        validate={required()}
      />
      <ReferenceInput
        fullWidth
        reference="risk-levels"
        source="riskId"
        validate={required()}
      >
        <SelectInput />
      </ReferenceInput>
      <TextInput source="name" validate={required()} fullWidth />
    </SimpleForm>
  </Edit>
);

export default ProvinceEdit;
